import { useQuery } from '@tanstack/react-query';
import { ProjectAPI } from 'api/project';

export const useGetAllProjectsQuery = () => {
  return useQuery({
    queryKey: ['projects'],
    queryFn: () => ProjectAPI.getProjectList(),
  });
};
export const useGetInitQuery = () => {
  return useQuery({
    queryKey: ['init'],
    queryFn: () => ProjectAPI.init(),
  });
};
